import {
  createContext,
  type FC,
  type ReactNode,
  type RefObject,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from 'react'

type ProductCarouselFocusContextType = {
  focusItem: (index: number) => void
  itemRefs: RefObject<(HTMLButtonElement | null)[]>
}

const ProductCarouselFocusContext = createContext<
  ProductCarouselFocusContextType | undefined
>(undefined)

export const useOptionalProductCarouselFocus = ():
  | ProductCarouselFocusContextType
  | undefined => {
  return useContext(ProductCarouselFocusContext)
}

export const ProductCarouselFocusProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const focusItem = useCallback((index: number) => {
    itemRefs.current[index]?.focus()
  }, [])

  const value = useMemo(() => ({ focusItem, itemRefs }), [focusItem])

  return (
    <ProductCarouselFocusContext.Provider value={value}>
      {children}
    </ProductCarouselFocusContext.Provider>
  )
}
